export const productExtras = {
  'hygienx-300': {
    buyingGuide: "Choose the HygienX 300 if you want fully hands-free floor care in a 2-5BHK home or duplex: its 15,000Pa suction handles fine Indian dust and pet hair, LiDAR maps multiple floors, and the all-in-one dock empties dust, washes mops and dries them at 55°C so you touch the robot only minutes per month. If your budget is tighter and you can empty a dustbin weekly, consider the LumineX 300 instead — but for allergy-sensitive families and premium homes, the HygienX 300's HEPA H12 filtration and self-maintaining dock are worth every rupee.",
    comparison: {
      columns: ['', 'HygienX 300', 'Typical Mid-Range Robot', 'Manual Cleaning'],
      rows: [
        ['Suction Power', '15,000Pa', '4,000-6,000Pa', '—'],
        ['Navigation', 'LiDAR + AI obstacle avoidance', 'Gyroscope / random', 'Depends on staff'],
        ['Mop Care', 'Auto wash + 55°C hot-air dry', 'Manual wash', 'Manual'],
        ['Dust Handling', 'Self-empty dock (weeks)', 'Daily manual emptying', 'Daily'],
        ['Filtration', 'H12 HEPA 3-layer (99.97%)', 'Basic filter', 'None (raises dust)'],
        ['Daily Effort', '~0 minutes', '5-10 minutes', '45-60 minutes'],
        ['Annual Cost (3-yr avg)', '~₹30,000', '~₹18,000 + your time', '₹40,000-60,000 (help)'],
      ],
    },
    maintenance: [
      'Weekly: rinse the dock\'s wash tray and check side brushes for wrapped hair',
      'Monthly: wipe LiDAR turret and cliff sensors with a dry cloth; empty the dock dust bag if full',
      'Every 3 months: replace mop pads if worn; wash the HEPA filter (air-dry fully)',
      'Every 6-12 months: replace HEPA filter and side brushes (genuine spares available pan-India)',
    ],
    installation: [
      'Doorstep delivery within 2-5 business days across India',
      'Technician places and levels the all-in-one dock near a power point with 0.5m clearance',
      'First mapping run completes in 10-20 minutes; rooms are auto-detected and named',
      'App setup on your phone: schedules, no-go zones, voice assistant linking',
      'Demo of dust-bag replacement and mop care before handover',
    ],
    caseStudy: {
      title: 'Case Study: 4BHK Duplex, Gurugram',
      body: 'A family of five in DLF Phase 2 with two dogs replaced twice-daily manual sweeping with a single HygienX 300. Result after 90 days: pet hair eliminated from under beds and sofas (the robot cleans there daily), visible reduction in dust settling on furniture thanks to HEPA capture, and mop odour eliminated during monsoon by the hot-air dock. The household reclaimed roughly 25 staff-hours per month and reports the home "guest-ready every morning".',
    },
  },
  'luminex-300': {
    buyingGuide: "The LumineX 300 is the value sweet spot for 1-3BHK apartments: genuine LiDAR navigation, simultaneous vacuum-and-mop and app scheduling at ₹39,990. You empty the dustbin and rinse mops yourself — a fair trade at this price. Upgrade to the HygienX 300 if you want the self-cleaning dock and stronger suction for pets and larger homes.",
    comparison: {
      columns: ['', 'LumineX 300', 'Budget Robots (<₹20k)', 'Manual Cleaning'],
      rows: [
        ['Navigation', 'LiDAR systematic mapping', 'Random bounce', 'Depends on staff'],
        ['Vacuum + Mop', 'Simultaneous', 'Usually vacuum-only', 'Separate passes'],
        ['App & Scheduling', 'Full app, zones, schedules', 'Basic remote', 'None'],
        ['Coverage Consistency', 'Complete, logged', 'Misses areas', 'Varies daily'],
        ['Daily Effort', '2-3 minutes', '10+ minutes (rescues)', '45-60 minutes'],
      ],
    },
    maintenance: [
      'After mopping: rinse mop pad and air-dry; empty dustbin every 2-3 days',
      'Weekly: clear hair from the main brush and side brushes',
      'Monthly: wipe sensors and charging contacts; wash filter and dry fully',
      'Every 6 months: replace filter and mop pads for peak performance',
    ],
    installation: [
      'Free doorstep delivery and unboxing assistance',
      'Dock placement against a wall with 0.5m side clearance',
      'Guided first mapping run and room labelling in the app',
      'Schedule setup and no-go zones configured with you',
    ],
    caseStudy: {
      title: 'Case Study: 2BHK Apartment, Noida Sector 137',
      body: 'A working couple scheduled the LumineX 300 to clean daily at 11 AM. After 60 days: floors stay dust-free without weekend deep-cleans, the balcony-adjacent living room (previously dust-prone) is maintained automatically, and their part-time help now focuses on kitchen and bathrooms only — cutting help hours by a third.',
    },
  },
  'robo-titan': {
    buyingGuide: "Choose the Robo Titan for commercial pools — hotels, clubs, societies and institutions with pools up to 2,500 m². Its 40,000 L/hr filtration, four debris intake gates and programmable schedules deliver guest-ready water every morning without a pool operator. For villa pools under 1,800 m², the Robo Dressel offers similar automation at a lower price.",
    comparison: {
      columns: ['', 'Robo Titan', 'Suction-Side Cleaners', 'Manual Pool Boy'],
      rows: [
        ['Coverage', 'Floor + walls + waterline (2,500 m²)', 'Floor only', 'Partial, varies'],
        ['Filtration', 'Independent 20µm, 40,000 L/hr', 'Uses pool filter (coarse)', 'None'],
        ['Scheduling', 'Programmable cycles', 'Runs with pump', 'Shift-dependent'],
        ['Chemical Impact', '30-40% lower consumption', 'No change', 'No change'],
        ['Annual Cost', 'Electricity + minor spares', 'Higher pump wear', '₹2.5-4 lakh labour'],
      ],
    },
    maintenance: [
      'After each cycle: rinse filter baskets; check intake gates for large debris',
      'Weekly: inspect brushes and tracks; wipe the cable and check for kinks',
      'Monthly: deep-rinse filters; inspect impeller for hair/fibre wrap',
      'Seasonally: professional inspection under AMC; store dry if pool is winterised',
    ],
    installation: [
      'Site survey (pool dimensions, power availability) — free for commercial clients',
      'Delivery, caddy assembly and first supervised cleaning cycle',
      'Schedule programming aligned to guest hours (e.g., 2 AM daily)',
      'Staff training on filter cleaning and safe handling; ROI reporting setup',
    ],
    caseStudy: {
      title: 'Case Study: Resort Pool, North Goa',
      body: 'A 40-room boutique resort running a 320 m² pool switched from a two-person morning cleaning crew to a Robo Titan on a 2 AM schedule. Over one season: water clarity complaints dropped to zero, chlorine consumption fell ~35% due to continuous fine filtration, and the crew was redeployed to garden upkeep. Management recovered the robot\'s cost in under 11 months.',
    },
  },
  'robo-dressel': {
    buyingGuide: "The Robo Dressel is the right choice for villa and society pools up to 1,800 m²: triple-motor power, wall and waterline climbing, and 20-micron filtration in a package one person can lift into the pool. If you operate a large hotel or institutional pool, step up to the Robo Titan for higher throughput and scheduling headroom.",
    comparison: {
      columns: ['', 'Robo Dressel', 'Suction-Side Cleaners', 'Manual Cleaning'],
      rows: [
        ['Coverage', 'Floor + walls + waterline (1,800 m²)', 'Floor only', 'Partial'],
        ['Power', 'Triple-motor drive & scrub', 'Pump-dependent', '—'],
        ['Filtration', 'Independent 20µm', 'Pool filter (coarse)', 'None'],
        ['Effort', 'Drop in, press start', 'Manual hose setup', '1-2 hrs per session'],
        ['Chemical Impact', '30-40% lower usage', 'No change', 'No change'],
      ],
    },
    maintenance: [
      'After each cycle: rinse the filter basket under running water',
      'Weekly: check brushes for debris; inspect floating cable',
      'Monthly: clean impeller area; check tracks/rollers for wear',
      'Off-season: store dry, out of sunlight, cable loosely coiled',
    ],
    installation: [
      'Doorstep delivery across India in 3-7 business days',
      'On-site orientation: safe lowering, cycle selection, retrieval',
      'Filter cleaning demonstration and app walkthrough (if applicable)',
      'Optional AMC enrolment for villa and society clients',
    ],
    caseStudy: {
      title: 'Case Study: Villa Pool, Kokapet, Hyderabad',
      body: 'A villa owner with a 12m private pool ended a ₹6,000/month pool-boy contract after installing the Robo Dressel. Daily one-hour cycles keep the floor, walls and waterline algae-free; leaf load from surrounding trees is handled by the high-capacity basket. Net saving of ~₹70,000/year with visibly clearer water — and weekend swims no longer wait for the cleaner\'s visit.',
    },
  },
  'shinebot-c2': {
    buyingGuide: "Choose the ShineBot C2 if you have large glass areas that are risky or tedious to clean: high-rise apartment windows, villa glass walls, balcony railings or office partitions. It works on framed and frameless glass, sprays and squeegees automatically, and its layered safety systems (continuous suction monitoring, backup battery, 100kg safety rope) make it the safe alternative to ladders and rope-access crews.",
    comparison: {
      columns: ['', 'ShineBot C2', 'Professional Crew', 'Manual (self)'],
      rows: [
        ['Exterior High-Rise Glass', 'Yes, safely from inside', 'Yes (₹3,000-8,000/visit)', 'Unsafe'],
        ['Frameless Glass & Railings', 'Yes (AI edge detection)', 'Yes', 'Partial'],
        ['Frequency', 'Whenever you like', 'Monthly at best', 'Rarely'],
        ['Streak-Free Finish', 'AI spray + squeegee path', 'Skill-dependent', 'Inconsistent'],
        ['Annual Cost', 'One-time + pads', '₹36,000-96,000', 'Your time & risk'],
      ],
    },
    maintenance: [
      'After each session: wash cleaning pads; refill spray tank with recommended solution',
      'Weekly (regular use): wipe edge sensors and suction ring',
      'Monthly: inspect safety rope and carabiner for wear — replace if frayed',
      'Every 6 months: replace cleaning pads for streak-free results',
    ],
    installation: [
      'Delivery with pads, spray solution and safety rope included',
      'On-site demo: anchoring the safety rope, starting on your own glass',
      'Guidance for frameless edges, railings and mirrors',
      'App pairing and cleaning-pattern selection',
    ],
    caseStudy: {
      title: 'Case Study: 18th-Floor Apartment, Worli, Mumbai',
      body: 'A sea-facing apartment\'s exterior glass had not been properly cleaned in two years — professional access cost ₹7,500 per visit. With the ShineBot C2 anchored indoors, the owner now cleans all exterior panes monthly in under an hour of supervision. Salt-haze buildup is gone, and the robot paid for itself versus crew visits within the first year.',
    },
  },
};
